@if (loadingState) {
  <dcp-loading-page [loadingText]="loadingScreenText"/>
} @else {
  <div class="udex-grid udex-mx-auto udex-pt-16">
    <h3 class="udex-mb-8">SAP for Me Simulation &amp; Testing Page</h3>

    @if (user$ | async; as user) {
      <h4 class="udex-mb-16">
        Logged in as: {{user.name}} ({{user.email}})
      </h4>
    }

    <udex-text-field
      label="Enter S-user ID"
      value-state="Standard"
      aria-described-by="sUserIdHelp"
      id="sUserId"
      class="udex-mb-8"
      [value]="sUserId"
      (input)="onInput($event)">
    </udex-text-field>

    <p id="sUserIdHelp" class="udex-mb-8 body--s">
      Enter the S-user ID you want to display transactions for, then click on "Get Transactions".<br/>
      Click the Reset button to clear input and transactions list<br/>
      To use "Update cache" functionality, please, input S-user ID
    </p>

    <div class="d-flex gap-4 udex-mb-8">
      <udex-button
        (click)="getTransactions(sUserId)"
        class="udex-button--wide"
        size="Large"
        design="Primary">
        Get Transactions
      </udex-button>

      <udex-button
        (click)="onReset()"
        class="udex-button--wide"
        size="Large"
        design="Secondary">
        Reset
      </udex-button>

      <udex-button
        [disabled]="!sUserId"
        (click)="updateCache(sUserId)"
        class="udex-button--wide"
        size="Large"
        design="Secondary">
        Update Cache
      </udex-button>
    </div>

    <dcp-iframe
      [url]="previewUrl"
      [show]="hasPreviewUrl()"
      (closeEvent)="previewUrl = null"
      title="CTA IFrame"
    ></dcp-iframe>

    <udex-table
      sticky-column
      heading="Displaying transactions for {{currentUser}}"
      no-data-text="No data"
      loading-delay="1000">
      <udex-table-header-row slot="headerRow">
        <udex-table-header-cell>CRM Provider Contract</udex-table-header-cell>
        <udex-table-header-cell>ERP Contract Item ID</udex-table-header-cell>
        <udex-table-header-cell>Item No</udex-table-header-cell>
        <udex-table-header-cell>Material ID</udex-table-header-cell>
        <udex-table-header-cell>CTA Type</udex-table-header-cell>
        <udex-table-header-cell>Validation</udex-table-header-cell>
        <udex-table-header-cell>Action</udex-table-header-cell>
        <udex-table-header-cell>Target URL</udex-table-header-cell>
      </udex-table-header-row>
      @if (transactions$ | async; as transactions) {
        @for (document of transactions.referencedDocuments; track $index) {
          @for (item of document.items; track $index) {
            @for (cta of item.callToActions; track $index) {
              <udex-table-row>
                <udex-table-cell>{{document.id}}</udex-table-cell>
                <udex-table-cell> {{item.contractItemId}}</udex-table-cell>
                <udex-table-cell>{{item.number}}</udex-table-cell>
                <udex-table-cell>{{item.product}}</udex-table-cell>
                <udex-table-cell>{{cta.code}}</udex-table-cell>
                <udex-table-cell>
                  @if (cta.error) {
                    {{cta.error.code}}<br/>
                    {{cta.error.description}}
                  }
                </udex-table-cell>
                <udex-table-cell>
                  @if (cta.targetUrl) {
                    <udex-button
                      (click)="togglePreview(convertUrlToCurrentHostname(cta.targetUrl))"
                      [attr.data-cy]="item.product"
                      size="Large"
                      design="Primary">
                      {{cta.name}}
                    </udex-button>
                  }
                </udex-table-cell>
                <udex-table-cell>
                  @if (cta.targetUrl) {
                    <udex-button
                      [cdkCopyToClipboard]="cta.targetUrl"
                      size="Large"
                      design="Primary">
                      Copy URL
                    </udex-button>
                  }
                </udex-table-cell>
              </udex-table-row>
            }
          }
        }
      }
    </udex-table>
  </div>
}
